import * as React from "react"
import { Language } from "fgr-lib-business-logic/lib/receipts/localization/types"

interface State {
    productSearchValue: string | null
    productSearchIsActive: boolean
    currency: string
    browserLanguage: Language
}

export interface UiContextInterface {
    productSearchValue: string | null
    productSearchIsActive: boolean
    setProductSearchValue: (value: string) => void
    setProductSearchIsActive: (isActive: boolean) => void
    isUSLanguage: () => boolean
    browserLanguage: Language
    setBrowserLanguage: (locale: Language) => void
    setCurrency: (currency: string) => void
}

type Props = {
    children: React.ReactNode
}

export const UiContext = React.createContext<UiContextInterface | null>(null)

class UiProvider extends React.PureComponent<Props, State> {
    state = {
        productSearchValue: "",
        productSearchIsActive: false,
        currency: "USD",
        browserLanguage: Language.enUS as Language,
    }

    setProductSearchValue = (value: string) => {
        this.setState({ productSearchValue: value })
    }

    setProductSearchIsActive = (isActive: boolean) => {
        this.setState({
            productSearchIsActive: isActive,
            productSearchValue: !isActive ? "" : this.state.productSearchValue,
        })
    }

    isUSLanguage = () => this.state.currency === "USD"

    setCurrency = (currency: string) => this.setState({ currency: currency })

    setBrowserLanguage = (language: Language) => this.setState({ browserLanguage: language })

    render = () => (
        <UiContext.Provider
            value={{
                productSearchValue: this.state.productSearchValue,
                productSearchIsActive: this.state.productSearchIsActive,
                setProductSearchValue: this.setProductSearchValue,
                setProductSearchIsActive: this.setProductSearchIsActive,
                isUSLanguage: this.isUSLanguage,
                setCurrency: this.setCurrency,
                browserLanguage: this.state.browserLanguage,
                setBrowserLanguage: this.setBrowserLanguage,
            }}>
            {this.props.children}
        </UiContext.Provider>
    )
}

const LayoutConsumer = UiContext.Consumer

export { LayoutConsumer, UiProvider }
